import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { IntercomService } from './shared/services/intercom.service';
import { MatIconSvgRegistry } from "./shared/services/mat-icon-svg-registry";
import { FontAwesomeIconRegistry } from './shared/services/fontawesome-icon-registry';
import { AuthenticationService, INITIAL_GLOBAL_LOADING_TAG, InitService } from './core/services';
import { LoadingService, SessionCookieService, FeatureFlagService, SidenavService, SideContainerInterface } from './shared/services';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Chart, registerables } from 'chart.js';
import { ChoroplethController, ColorScale, GeoFeature, ProjectionScale } from 'chartjs-chart-geo';
import { WordCloudController, WordElement } from 'chartjs-chart-wordcloud';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent<T> {
    sidenavContent: Signal<SideContainerInterface<T>> = this.sidenavService.content;
    sidenavOpened: Signal<boolean> = this.sidenavService.opened;

    readonly isInitialLoading$: Observable<boolean> = this.loadingService.getIsLoading(INITIAL_GLOBAL_LOADING_TAG);
    readonly isLoggedIn$: Observable<boolean> = this.initService.isInitialized$.pipe(distinctUntilChanged());

    constructor(
        private readonly intercomService: IntercomService,
        private readonly authenticationService: AuthenticationService,
        private readonly featureFlagService: FeatureFlagService,
        private readonly sessionCookieService: SessionCookieService,
        private readonly loadingService: LoadingService,
        private readonly matIconSvgRegistry: MatIconSvgRegistry,
        private readonly fontAwesomeIconRegistry: FontAwesomeIconRegistry,
        private readonly initService: InitService,
        private readonly sidenavService: SidenavService<T>,
    ) {
        this.intercomService.setupIntercomStub();
        this.authenticationService.initTabSharing();
        this.featureFlagService.initialize();
        this.sessionCookieService.init();
        this.matIconSvgRegistry.init();
        this.fontAwesomeIconRegistry.init();
        this.registerChartJS();
    }

    onOpenSidenav(): void {
        this.sidenavService.open();
    }

    onCloseSidenav(): void {
        this.sidenavService.close();
    }

    private registerChartJS(): void {
      Chart.register(...registerables, ChoroplethController, GeoFeature, ProjectionScale, ColorScale, WordCloudController, WordElement);
    }
}
